import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { RxjsComponent } from '@smooved/core';
import { SelectInput } from '@smooved/ui';
import { takeUntil } from 'rxjs/operators';
import { Score } from '../../interfaces/meta/questions/score';

@Component({
    selector: 'app-question-score-component',
    templateUrl: './question-score.component.html',
})
export class QuestionScoreComponent extends RxjsComponent implements OnInit {
    @Input() public question: Score;
    @Input() public group: UntypedFormGroup;

    public selectionOptions: SelectInput<any>[] = [];

    constructor(private translateService: TranslateService) {
        super();
    }

    public ngOnInit(): void {
        this.translateService.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(({ lang }) => {
            this.question?.groups?.forEach((group) => {
                this.selectionOptions = this.selectionOptions.concat(
                    group.scales.map((scale) => {
                        return {
                            id: `${this.question.id}-${scale.value}`,
                            name: this.question.id,
                            label: scale.label[lang],
                            value: scale.value,
                        };
                    })
                );
            });
        });
    }
}
